function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#DFEAFC;}\n\t.st1{fill:#387BF5;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Spitzkreis_blau_2_"
}, /*#__PURE__*/React.createElement("g", {
  id: "shape_Kopie_6_4_"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M54.9,3.9L108.7,0l4.1,56.4c2.2,31.1-21.2,58.2-52.3,60.4l-2.6,0.2C28.1,119.1,2.3,96.8,0.2,67.1 C-2.2,34.5,22.3,6.2,54.9,3.9z"
}))));

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M94.9,18.8c-14.3,0-26,11.7-26,26v36c0,14.3,11.7,26,26,26h36c14.3,0,26-11.7,26-26v-36c0-14.3-11.7-26-26-26 C130.9,18.8,94.9,18.8,94.9,18.8z M94.9,22.8h36c12.2,0,22,9.8,22,22l0,36c0,12.2-9.8,22-22,22h-36c-12.2,0-22-9.8-22-22v-36 C72.9,32.6,82.8,22.8,94.9,22.8z M136.9,34.8c-2.2,0-4,1.8-4,4s1.8,4,4,4s4-1.8,4-4S139.1,34.8,136.9,34.8z M112.9,40.8 c-12.1,0-22,9.9-22,22s9.9,22,22,22s22-9.9,22-22S125,40.8,112.9,40.8z M112.9,44.8c10,0,18,8,18,18c0,10-8,18-18,18s-18-8-18-18 S102.9,44.8,112.9,44.8z"
});

var SvgKontaktseiteInsta = function SvgKontaktseiteInsta(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 156.9 117.1",
    style: {
      enableBackground: "new 0 0 156.9 117.1"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgKontaktseiteInsta, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/KontaktseiteInsta.55a721f7.svg";
export { ForwardRef as ReactComponent };